import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import AuditTableRow from './AuditTableRow';
import OrderCell from "../../../common/components/OrderCell/OrderCell";

const sticky = {
  position: 'sticky',
  top: 0,
  backgroundColor: '#fff'
};

function AuditTable({ rows, triggerRefetch, permission, ordersBundle }) {
  return (
    <TableContainer component={Paper} sx={{width: 'auto', boxShadow: 'none', height: '100%'}}>
      <Table sx={{minWidth: 650}}>
        <TableHead>
          <TableRow>
            <OrderCell id="idHead" ordersBundle={ordersBundle} label={'Идентификатор'} orderField={'id'} sticky={sticky} />
            <OrderCell style={{ minWidth: '300px', maxWidth: '320px' }} id="dateHead" ordersBundle={ordersBundle} label={'Дата и время'} orderField={'ctime'} sticky={sticky} />
            <OrderCell id="actionTypeHead" ordersBundle={ordersBundle} label={'Тип события'} orderField={'actionType'} sticky={sticky} />
            <OrderCell id="dataTypeHead" ordersBundle={ordersBundle} label={'Тип данных'} orderField={'dataType'} sticky={sticky} />
            <OrderCell id="userHead" ordersBundle={ordersBundle} label={'Логин'} orderField={'changedByUser'} sticky={sticky} />
            <TableCell id={'descriptionHead'} sx={sticky}>Описание события</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (<AuditTableRow permission={permission} row={row} triggerRefetch={triggerRefetch} key={row.id} />))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default AuditTable;
